// VOLUMES
export const VolumeFields = [
  { title: "LVEDV (V)", range: "(ml)" },
  { title: "LVESV (V)", range: "(ml)" },
  { title: "SV", range: "(ml)" },
  { title: "CO", range: "(L/min)" },
  { title: "EF", range: ">55%" },
  { title: "FS", range: ">30%" },
  { title: "LV Mass", range: "(gram)" },
  { title: "LV Mass (C)", range: "(gram)" },
  { title: "HR", range: "(bpm)" },
];
export default VolumeFields;
